/* eslint-disable react/prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import React from "react"
import { useLocation } from "react-router-dom"

import * as S from "./style"
import ContactButton from "../ContactButton"

const Menu = ({ isVisible, checkFunction, navLinks, contactLabel, handleClose }) => {
  const createNavLink = link => (
    <S.NavLink key={link.text} to={link.to} smooth={link.smoothScroll} {...(link.matchPath && checkFunction(link.matchPath))} onClick={handleClose}>
      {link.text}
    </S.NavLink>
  )

  const { pathname } = useLocation()
  const currentLanguage = pathname.split("/")[1]

  return (
    <S.Menu $isVisible={isVisible}>
      <S.LinkContainer>{navLinks.map(link => createNavLink(link))}</S.LinkContainer>
      <S.ContactWrapper>
        <ContactButton label={contactLabel} size="full" onClick={handleClose} />
      </S.ContactWrapper>
      <S.LanguageContainer>
        <S.LanguageLink $isActive={currentLanguage === "en"} to="/en" onClick={handleClose}>
          en
        </S.LanguageLink>
        <S.LanguageLink $isActive={currentLanguage === "pt-br"} to="/pt-br" onClick={handleClose}>
          pt-br
        </S.LanguageLink>
      </S.LanguageContainer>
    </S.Menu>
  )
}

export default Menu
